import helpDetailLayout from "../../layout/helpDetail"

// 登录模块
export default {
    path: "/helpDetail",
    component: helpDetailLayout,
    redirect: "/helpDetail",
    alwaysShow: true,
    name: "Detail",
    children: [
        {
            path: "/helpDetail",
            name: "helpDetail",
            meta: {
                module: "helpDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/views/helpList/helpDetail/index")
        },
        {
            path: "/orderAdmin",
            name: "orderAdmin",
            meta: {
                module: "helpDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/webenterprise/orderAdmin/index")
        }
    ]
}